import React from 'react';
import classnames from 'classnames';

// import { ModalRawHTML } from '../../RawHTML/ModalRawHTML';
import { ReviewsIoComponentFragment } from '../../../../graphql.schema';
import ReviewsIoWidgetv2 from '../../Reviewsv2/ReviewsIoWidgetv2';

// import * as styles from './StrapiReviewsIOComponent.module.scss';

type StrapiReviewIOComponentPropType = ReviewsIoComponentFragment & {
  hasRTL?: boolean;
  loadDefer?: boolean;
};
export const StrapiReviewsIOComponent: React.FC<StrapiReviewIOComponentPropType> = ({
  heading,
  script,
  hasRTL = false,
  loadDefer,
}) => {
  const isV2 = process.env.GATSBY_IS_V2 === 'true';
  let styles = require('./StrapiReviewsIOComponent.module.scss');
  if (isV2) {
    styles = require('./StrapiReviewsIOComponent-v2.module.scss');
  }

  return (
    <div className={classnames(hasRTL ? 'mt-5' : '', styles.root)}>
      <h2 className={classnames('title is-2 has-text-centered', styles.title)}>{heading}</h2>
      <ReviewsIoWidgetv2 className={styles.carouselWidget} html={script?.htmlCode} loadDefer={loadDefer}/>
    </div>
  );
};
